"use client";

import React from "react";
import { HoldingChangeTable } from "@components/WhaleHoldings/WhaleHoldingsDetail/HoldingChangeTable";
import { ROUTER_PATH } from "@config/router";
import { ViewDetailsLink } from "./ViewDetailsLink";

interface WhaleHoldingChangeBusinessChartProps {
  cikId: string;
}

export const WhaleHoldingChangeBusinessChart: React.FC<
  WhaleHoldingChangeBusinessChartProps
> = ({ cikId }) => {
  return (
    <>
      <div className="w-full overflow-hidden">
        <HoldingChangeTable cikId={cikId} />
      </div>
      <ViewDetailsLink
        href={`${ROUTER_PATH.WHALE_HOLDINGS}/${encodeURIComponent(cikId)}`}
      />
    </>
  );
};
